import {Outlet, useNavigate} from "react-router-dom";
import {StickyHeader} from "@chayka/ui";
import {BackButton} from "../BackButton";

export const AuthLayout = () => {
  const navigate = useNavigate();

  return (
    <div className="relative flex flex-col justify-start items-center gap-5 w-full">
      <StickyHeader leftPart={<BackButton onClick={() => navigate("/guest", {replace: true})} />} />
      <div className="relative flex flex-1 flex-col justify-center items-center gap-10 w-full">
        <Outlet />
      </div>
    </div>
  );
};
